export const GET_SETTING_DATA = "GET_SETTING_DATA";
export const GET_WITHDRAWAL = "GET_WITHDRAWAL";
export const ADD_PAYMENT_GATEWAY = "ADD_PAYMENT_GATEWAY";
export const EDIT_PAYMENT_GATEWAY = "EDIT_PAYMENT_GATEWAY";
export const ACTIVE_SWITCH_PAYMENT_GATEWAY = "ACTIVE_SWITCH_PAYMENT_GATEWAY";
export const EDIT_SETTING = "EDIT_SETTING";
export const SWITCH_SETTING = "SWITCH_SETTING";

export const GET_ADS_DATA = "GET_ADS_DATA";
export const IS_ADS_CHANGE = "IS_ADS_CHANGE";
export const ADS_API_DATA = "ADS_API_DATA";

export const DELETE_WITHDRAW = "DELETE_WITHDRAW";
